import React, { useState, useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  TextField,
  makeStyles
} from '@material-ui/core';
import MusicianContext from 'src/musicianContext';
import MusicSnackbar from 'src/components/MusicSnackbar';
import { db } from 'src/db/db';

const useStyles = makeStyles(() => ({
  root: {}
}));

const ProfileDetails = ({ className, ...rest }) => {
  const classes = useStyles();
  const musician = useContext(MusicianContext);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const saveProfileChanges = async () => {
    setLoading(true);
    await db.collection("musicians").doc(musician.musician).set({
      displayName: values.displayName ? values.displayName : musician.displayName ? musician.displayName : (musician.musician ? musician.musician : "..."),
      phone: values.phone  ? values.phone : musician.phone ? musician.phone : "..."
    }, {merge: true})
    await db.collection("users").doc(musician.user.uid).set({
      phone: values.phone  ? values.phone : musician.phone ? musician.phone : "..."
    }, {merge: true})
    setLoading(false);
    setIsSnackbarOpen(true);
  };

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited"
          title="Profile"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="The creator of this musician."
                label="Created by"
                name="displayName"
                disabled
                value={musician.user ? musician.user.displayName : "..."}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="The app name displayed in the Alexa Skill Store."
                label="Display name"
                name="displayName"
                onChange={handleChange}
                required
                value={ values.displayName ? values.displayName : musician.displayName ? musician.displayName : (musician.musician ? musician.musician : "...")}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                disabled
                value={musician.user ? musician.user.email : "..."}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                type="number"
                value={ values.phone  ? values.phone : musician.phone ? musician.phone : "..."}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                label="Alexa Invocation Phrase"
                name="invocation"
                disabled
                value={"Alexa, open " + (musician.musician ? musician.musician : "...") + " experience"}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          display="flex"
          justifyContent="flex-end"
          p={2}
        >
          { 
            loading ?
            <CircularProgress color="primary" /> :
            <Button
              color="primary"
              variant="contained"
              onClick={saveProfileChanges}
            >
              Save details
            </Button>
          }
        </Box>
      </Card>
      <MusicSnackbar 
        text={`Success! Saved profile details.`}
        setOpen={setIsSnackbarOpen}
        open={isSnackbarOpen}
        severity="success"
      />
    </form>
  );
};

ProfileDetails.propTypes = {
  className: PropTypes.string
};

export default ProfileDetails;
